import { hero } from '@/mocks/chigua';

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="mx-auto max-w-[1200px] px-4 pb-14 pt-10 md:px-6 md:pb-20 md:pt-14">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
          {/* 文案区 · 上疏 */}
          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-paper-200 bg-paper-100/80 px-3 py-1.5">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
              <span className="text-xs font-medium tracking-wide text-ink-600">{hero.eyebrow}</span>
            </div>

            <h1 className="mt-6 font-heading text-[2rem] font-bold leading-[1.2] tracking-tight text-ink-900 md:text-[2.9rem]">
              {hero.titleA}
              <span className="mt-2 block text-[1.15rem] font-semibold leading-relaxed text-accent-700 md:text-2xl">
                {hero.titleB}
              </span>
            </h1>

            <p className="mt-5 max-w-xl text-[15px] leading-[1.9] text-ink-600">{hero.lead}</p>

            <ul className="mt-6 space-y-2.5">
              {hero.bullets.map((b) => (
                <li key={b} className="flex items-start gap-2.5 text-sm text-ink-700">
                  <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className="ri-check-line text-xs" />
                  </span>
                  {b}
                </li>
              ))}
            </ul>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="whitespace-nowrap rounded-md bg-ink-900 px-6 py-3 text-center text-sm font-medium text-paper-50 transition-colors hover:bg-accent-600"
              >
                从「脉络索引」开始
              </a>
              <a
                href="#stories"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('stories')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-ink-300 bg-transparent px-6 py-3 text-sm font-medium text-ink-800 transition-colors hover:border-accent-400 hover:text-accent-600"
              >
                <i className="ri-play-circle-line text-base" />
                先看本期焦点
              </a>
            </div>
          </div>

          {/* 配图区 · 克制单图 */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-xl border border-paper-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20editorial%20still%20life%20of%20layered%20cream%20paper%20documents%2C%20pinned%20newspaper%20clippings%2C%20scattered%20notes%20and%20a%20small%20terracotta%20seal%20stamp%20on%20a%20desk%2C%20soft%20side%20window%20light%2C%20muted%20beige%20and%20terracotta%20palette%2C%20minimal%20journalistic%20aesthetic%2C%20generous%20negative%20space%2C%20fine%20print%20magazine%20mood%2C%20high%20detail&width=1200&height=940&seq=chigua-hero-01&orientation=squarish"
                alt="98吃瓜幕后编辑部还原事件脉络的资料台面"
                className="h-[340px] w-full object-cover object-top md:h-[460px]"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-ink-900/60 to-transparent p-5">
                <p className="text-[13px] leading-relaxed text-paper-100">
                  <i className="ri-archive-2-line mr-1.5 align-[-2px]" />
                  {hero.heroMeta}
                </p>
              </div>
            </div>
            <div className="pointer-events-none absolute -right-3 -top-3 -z-10 h-24 w-24 rounded-full bg-ocher-200/50 blur-2xl" />
          </div>
        </div>

        {/* 数据条 */}
        <div className="mt-12 grid grid-cols-3 gap-3 border-y border-paper-200 py-5 md:mt-16 md:py-7">
          {hero.stats.map((s) => (
            <div key={s.label} className="flex flex-col items-start gap-1">
              <span className="font-heading text-2xl font-bold text-accent-700 md:text-4xl">
                {s.value}
              </span>
              <span className="text-xs text-ink-500 md:text-sm">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}